import { FormsMultilineInput, RadioGroup, RadioItem, Spinner } from '@platform/components';
import { SimplifiedUserRole, MatchDeclineReasonEnum } from '@platform/client/schemas';
import { Control, FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type MatchDecliningContentProps = {
  isSaving: boolean;
  userAccountType: SimplifiedUserRole;
  register: UseFormRegister<UpdateDiscoveryCallFormData>;
  control: Control<UpdateDiscoveryCallFormData>;
  setValue: UseFormSetValue<UpdateDiscoveryCallFormData>;
  selectedReason: MatchDeclineReasonEnum | undefined;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

const proDecliningReasons: RadioItem[] = [
  {
    value: MatchDeclineReasonEnum.other_choice,
    title: "I'm choosing a different organization",
  },
  {
    value: MatchDeclineReasonEnum.skills_alignment,
    title: "I don't have the right skills",
  },
  {
    value: MatchDeclineReasonEnum.availability,
    title: 'Timezone or availability reasons',
  },
  {
    value: MatchDeclineReasonEnum.other,
    title: 'Other',
  },
];

const orgRepDecliningReasons: RadioItem[] = [
  {
    value: MatchDeclineReasonEnum.other_choice,
    title: "I'm choosing a different professional",
  },
  {
    value: MatchDeclineReasonEnum.skills_alignment,
    title: "They don't have the right skills",
  },
  {
    value: MatchDeclineReasonEnum.project_fit,
    title: 'This project no longer fits my needs',
  },
  {
    value: MatchDeclineReasonEnum.availability,
    title: 'Timezone or availability reasons',
  },
  {
    value: MatchDeclineReasonEnum.other,
    title: 'Other',
  },
];

export const MatchDecliningContent = (props: MatchDecliningContentProps) => {
  const { isSaving, userAccountType } = {
    ...props,
  };

  return (
    <div className='flex flex-col gap-8 md:mt-8 items-stretch md:w-[500px]'>
      {isSaving ?
        <Spinner />
      : <>
          <div className='text-center text-xl'>Can you tell us why this wasn't a good fit?</div>
          <div className='mt-4'>
            {/* TODO: Handle the org rep case */}
            <RadioGroup
              name='decline-reason'
              aria-label='decline-reason'
              items={
                userAccountType === SimplifiedUserRole.PROFESSIONAL ?
                  proDecliningReasons
                : orgRepDecliningReasons
              }
              onChange={(value) => {
                props.setValue('reason', value as MatchDeclineReasonEnum, {
                  shouldValidate: true,
                });
              }}
              register={() =>
                props.register('reason', { required: 'Select one option to continue' })
              }
              defaultValue={props.selectedReason}
              error={props.formState.errors.reason?.message}
            />
          </div>
          <div className='mt-4'>
            <div className='text-sm'>
              {userAccountType === SimplifiedUserRole.PROFESSIONAL ?
                "Anything you'd like to share with the MovingWorlds team? (optional)"
              : 'Additional details'}
            </div>
            <FormsMultilineInput
              control={props.control}
              name='declineReasonDetails'
              characterCount={500}
              placeholder="Tell us more about why this wasn't a good fit..."
            />
          </div>
        </>
      }
    </div>
  );
};
